export const messages = {
  title: {
    id: "library.title",
    defaultMessage: "Library",
  },
};
